import {
  ProductPurchaseDetails,
  ProductPurchasingController,
} from '../types/Purchasing';

type UseProductPricingProps<T extends ProductPurchaseDetails> = {
  purchasing: ProductPurchasingController<T>;
};

export function useProductPricing({
  purchasing,
}: UseProductPricingProps<ProductPurchaseDetails>) {
  if (!purchasing.product) return undefined;

  const totalFrame =
    purchasing.frame?.variant.consolidatedVariants.reduce(
      (acc, item) => acc + item.price * item.quantity,
      0,
    ) ?? 0;

  return purchasing.product.price + totalFrame;
}
